var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "align-center", attrs: { row: "", wrap: "" } },
        [
          _vm.item.isSuccess
            ? _c(
                "div",
                { staticStyle: { flex: "1 0" } },
                [
                  _vm._l(_vm.keysToDisplay, function (dataType, i) {
                    return [
                      _c(
                        "v-tooltip",
                        {
                          key: `${dataType.key}-${i}`,
                          attrs: {
                            disabled: dataType.key != "newResults",
                            bottom: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-chip",
                                      _vm._g(
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            color: "transparent",
                                            label: "",
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-avatar",
                                          { staticClass: "mr-0" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "no-transition",
                                                attrs: { color: "secondary" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      dataType.icon
                                                        ? dataType.icon
                                                        : _vm.getMediaTypeIcon(
                                                            _vm.item.mediaType
                                                          )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "headline font-weight-regular mr-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.item[dataType.key]) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isSurveyData
                                          ? _c(
                                              "span",
                                              {
                                                class: {
                                                  "grey--text text--darken-1":
                                                    !_vm.hover,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                New " +
                                                    _vm._s(
                                                      _vm.pluralize(
                                                        dataType.displayName,
                                                        _vm.item[dataType.key]
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.item.mediaType || "Unknown")),
                            ]),
                            _vm._v(" media type"),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              )
            : _c("v-card-text", { staticStyle: { flex: "1 0" } }, [
                _vm._v(
                  "\n      Data ingestion failed. Review the file or view the logs for details.\n    "
                ),
              ]),
          _vm._v(" "),
          _c("div", [
            _vm.item.fileName
              ? _c(
                  "div",
                  { staticClass: "text-xs-right" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", "open-delay": 300 },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _vm.item.executionId != null &&
                                  _vm.item.isIngestion
                                    ? _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              to: {
                                                name: "dataset",
                                                params: { id: _vm.item.fileId },
                                              },
                                              depressed: "",
                                              small: "",
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v("attach_file")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-none" },
                                            [_vm._v(_vm._s(_vm.item.fileName))]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            href:
                                              "/uploads/" + _vm.item.FullName,
                                            download: "",
                                            depressed: "",
                                            small: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v("attach_file")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-none" },
                                            [_vm._v(_vm._s(_vm.item.fileName))]
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2736688529
                        ),
                      },
                      [_vm._v(" "), _c("span", [_vm._v(" File name ")])]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.item.cocCodes
              ? _c(
                  "div",
                  { staticClass: "text-xs-right" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", "open-delay": 300 },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-chip",
                                    _vm._g(
                                      { attrs: { small: "", label: "" } },
                                      on
                                    ),
                                    [
                                      _c("v-icon", { staticClass: "mr-2" }, [
                                        _vm._v("link"),
                                      ]),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.item.cocCodes) +
                                          "\n            "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3135123841
                        ),
                      },
                      [_vm._v(" "), _c("span", [_vm._v(" COC Code ")])]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.rollbackItem
        ? [
            _c(
              "v-card-title",
              { staticClass: "card-bg-2 py-0" },
              [
                _c(
                  "v-icon",
                  { staticClass: "mr-2", attrs: { color: "error" } },
                  [_vm._v("error")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "font-weight-medium" }, [
                  _vm._v("This import was rolled back"),
                ]),
                _vm._v(" "),
                _c(
                  "TertiaryBtn",
                  {
                    attrs: {
                      to: {
                        name: "allimports",
                        query: { search: _vm.rollbackItem.rollbackId },
                      },
                      small: "",
                      icon: "find_in_page",
                    },
                  },
                  [_vm._v("Go to rollback")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c(
              "v-card-text",
              { staticClass: "py-0" },
              [
                _vm.rollbackItem
                  ? _c("RollbackRun", {
                      attrs: { hover: _vm.hover, item: _vm.rollbackItem },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }